import { render, staticRenderFns } from "./POIConference.vue?vue&type=template&id=24e2f28c"
import script from "./POIConference.js?vue&type=script&lang=js&external"
export * from "./POIConference.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports